
$('.fontsize-choices [data-fontsize]').on('click',function(e){
    e.preventDefault();
    const $link = $(this);
    const $size = $link.attr('data-fontsize');

    $('.fontsize-choices [data-fontsize]').removeClass('active');
    $link.addClass('active');

    $('html').css('font-size', $size+'px');

    $.ajax({
        url: themeajax.ajaxurl,
        type: "POST",
        dataType:'json',
        data: {
            action: 'univi_root_fontsize_ajax_action',
            fontsize: $size
        }
    });

});



